'use client';

import Link from 'next/link';
import { MapPin, ArrowRight } from 'lucide-react';
import Image from 'next/image';

export default function PopularAreas() {
  const areas = [
    {
      name: 'Makati CBD',
      count: 45,
      description: 'Premier business district with Grade A offices and commercial spaces.',
      image: '/images/placeholders/bgc-condo.jpg'
    },
    {
      name: 'Bonifacio Global City',
      count: 38,
      description: 'Modern business hub with mixed-use developments and corporate offices.',
      image: '/images/placeholders/bgc-condo-2.jpg'
    },
    {
      name: 'Ortigas Center',
      count: 32,
      description: 'Central location with office towers, retail spaces, and accessibility.',
      image: '/images/placeholders/bgc-condo-3.jpg'
    },
    {
      name: 'Alabang',
      count: 28,
      description: 'Growing business district with warehouses and commercial developments.',
      image: '/images/placeholders/bgc-condo-4.jpg'
    }
  ];

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-100 rounded-full mb-4">
            <MapPin className="w-4 h-4 text-[#d60500]" />
            <span className="text-sm font-semibold text-[#d60500]">Browse by Area</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Prime Business Districts
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore commercial properties in Metro Manila's top business locations
          </p>
        </div>

        {/* Areas Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {areas.map((area, index) => (
            <Link
              key={index}
              href={`/properties?search=${area.name}&property_type=commercial,office,warehouse`}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-200 hover:border-[#d60500] hover:shadow-xl transition-all duration-300"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden bg-gray-100">
                <Image
                  src={area.image}
                  alt={area.name}
                  fill
                  className="object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                {/* Count Badge */}
                <div className="absolute top-4 right-4 px-3 py-1.5 bg-[#d60500] text-white rounded-full text-sm font-semibold">
                  {area.count} listings
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-[#d60500] transition-colors">
                  {area.name}
                </h3>
                <p className="text-gray-600 mb-4">
                  {area.description}
                </p>
                <div className="flex items-center gap-2 text-[#d60500] font-semibold group-hover:gap-3 transition-all">
                  View commercial properties
                  <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
